"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APIFrame.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var APIFrame = function APIFrame(props) {
  var children = props.children,
    customClass = props.customClass,
    id = props.id,
    src = props.src,
    title = props.title,
    onLoad = props.onLoad;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('kyc-iframe');
  return /*#__PURE__*/_react["default"].createElement("iframe", {
    allow: "camera",
    title: title,
    className: bemClasses(customClass),
    id: id,
    src: src,
    onLoad: onLoad
  }, children);
};
APIFrame.defaultProps = {
  id: '',
  src: '',
  onLoad: function onLoad() {},
  title: 'kyc-iframe',
  customClass: ''
};
APIFrame.propTypes = {
  id: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired,
  onLoad: _propTypes["default"].func,
  title: _propTypes["default"].string,
  customClass: _propTypes["default"].string
};
var _default = exports["default"] = APIFrame;